import { TextInput as RNTextInput } from "react-native";
import { Row } from "./row";
import { textInputStyles } from "./text-input";
import { Icon } from "./icon";
import { createStyles } from "../theme";

type Props = {
  onChange: (value: string) => void;
  placeholder?: string;
  value?: string;
};

export function SearchInput({ onChange, ...rest }: Props) {
  return (
    <Row.LR style={[textInputStyles.container, $.container]}>
      <RNTextInput
        {...rest}
        onChangeText={onChange}
        style={[textInputStyles.text, $.input]}
      />
      <Icon name="magnify" />
    </Row.LR>
  );
}

const $ = createStyles({
  container: {
    borderWidth: 1,
    borderColor: "outline",
  },
  input: {
    flex: 1,
    height: 54,
  },
});
